/* eslint-disable jsx-a11y/anchor-is-valid */

import { Outlet, Route, Routes } from 'react-router-dom'
import { useEffect } from 'react'
import { useThemeMode } from '../../../_metronic/partials'
import { LoginTeleConsulta } from './components/LoginTeleConsulta'
import { AtendimentoTeleConsulta } from './components/AtendimentoTeleConsulta'
import { CancelarTeleConsulta } from './components/CancelarTeleConsulta'
import { ConsentimentoTeleConsulta } from './components/ConsentimentoTeleConsulta'

const AuthLayout = () => {
  const { updateMode, updateMenuMode } = useThemeMode()
  useEffect(() => {
    updateMenuMode('light')
    updateMode('light')
  }, [updateMenuMode, updateMode])
  return (
    // Altura travada na viewport para a tela de vídeo caber com o chat. `100dvh` desconta a barra do
    // navegador em tablet/celular (onde `100vh` é maior que a área visível); `vh-100` fica de fallback.
    <div className='d-flex flex-column vh-100 overflow-hidden' style={{ height: '100dvh' }}>
      <nav className='navbar navbar-expand-lg navbar-primary bg-primary'>
        <div className='container-fluid'>
          <div className='navbar-brand d-block mx-auto'>
            <img src='/media/logos/logo-dark.png' alt='Logo' style={{ maxWidth: '150px' }} />
          </div>
        </div>
      </nav>

      {/* Rolagem aqui: login, termo e cancelamento podem passar da altura da tela (tablet deitado);
          sem ela o botão do fim fica cortado e inalcançável. O vídeo ocupa h-100 e não rola. */}
      <div
        className='flex-grow-1 d-flex flex-column p-0 m-0 overflow-auto'
        style={{ minHeight: 0 }}
      >
        <Outlet />
      </div>
    </div>
  )
}

export const TeleConsultaPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='/:protocolo' element={<LoginTeleConsulta />} />
      <Route path='/:protocolo/consentimento' element={<ConsentimentoTeleConsulta />} />
      <Route path='/:protocolo/atendimento' element={<AtendimentoTeleConsulta />} />
      <Route path='/:protocolo/cancelar' element={<CancelarTeleConsulta />} />
    </Route>
  </Routes>
)
